import { REST_URI } from 'lib/appConfig';
import session from 'lib/api/links/session';
import { getAuthHeaders } from 'lib/api/links/helpers';

/**
 * POST /operator-view/machines/:machineRef/time-options
 * @param {number} machineRef
 * @param {object} input - { jobStart?, jobEnd?, signIn? }
 * @param {{ signal?: AbortSignal }} [options]
 * @returns {Promise<object>} API body, e.g. { signIn: { options: [...] } }
 */
export const postTimeOptions = async (machineRef, input, options = {}) => {
  const apiKey = await session.getApiKey();
  const res = await fetch(
    `${REST_URI}/operator-view/machines/${machineRef}/time-options`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(apiKey),
      },
      body: JSON.stringify(input),
      signal: options.signal,
    }
  );

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `time-options failed: ${res.status}`);
  }

  return res.json();
};
